import { BCMSStateManagerCRUD } from "@bcm-dev/bcms-vite";
import LoginPage, { getDefaultPageData } from "components/pages/LoginPage";

/**
 * @name CaptureSoftTokenActivationUserIDEntered
 * @returns {React.Component}
 * @description A capture component in the capture group "Soft Tokens - Activation".
 */
export default function CaptureSoftTokenActivationUserIDEntered(props) {
    const data = BCMSStateManagerCRUD.init(getDefaultPageData())
    .update([ "userID" ], "DemoUser")
    .update([ "password" ], "")
    .submit();

    return <LoginPage data={ data } />
}